import { Box, IconContentView, Text } from 'ui'
import { DollarSign } from 'lucide-react'
import { formatCurrency } from 'lib/string'
import { getShiftBonus, getShiftPay } from 'lib/payment'
import { useShiftDetail } from './useShiftDetail'

export const ShiftDetailPayRate = () => {
  const { shift } = useShiftDetail()
  if (!shift) return null

  const payRate = formatCurrency(getShiftPay(shift))
  const bonus = getShiftBonus(shift)

  return (
    <Box>
      <IconContentView icon={<DollarSign size={20} />} iconProps={{ mr: 3 }}>
        <Box>
          <Text>
            {payRate}
            {shift.payLumpSum ? ' per worker' : '/hour per worker'}
            {bonus && Number(bonus) > 0
              ? ` • Bonus: ${formatCurrency(bonus)}`
              : null}
          </Text>
        </Box>
      </IconContentView>
    </Box>
  )
}
